module.exports = {
      id: "mail-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#mail",
      toString: function () {
        return this.url;
      }
    }